import { Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { ViewProposalContainerStyled } from './style';
type Props = {
  workApproach?: string;
  riskAssesment?: string;
  designApproach?: string;
};
const WorkApproach = (props: Props) => {
  return (
    <ViewProposalContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        WORK APPROACH
      </Typography>
      <VerticalSpaceStyled $space={30}>
        <InfoRowStyled>
          <Typography style={{ width: '210px' }}>Work Approach :</Typography>
          <Typography className="value">{props.workApproach}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography style={{ width: '210px' }}>
            Risk Assessment :
          </Typography>
          <Typography className="value">{props.riskAssesment}</Typography>
        </InfoRowStyled>

        <InfoRowStyled $direction="column">
          <Typography className="title">Design Approach :</Typography>
          <Typography className="value">{props.designApproach}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ViewProposalContainerStyled>
  );
};

export default WorkApproach;
